import { H3Text } from '@prisjakt/ui/text/variants';
import React, { useContext } from 'react';
import { AppContext } from 'src/components/app-context';
import LegalLink from 'src/components/newsletter-signup/legal-link';
import {
  Flex,
  Form,
  SubscribedCheckIcon,
  SubscribeTitle,
  Text,
} from 'src/components/newsletter-signup/styles';
import { useNewsletterSignup } from 'src/components/newsletter-signup/useNewsletterSignup';
import type { PrismicSliceNewsletter } from 'src/types';
import {
  Button,
  Container,
  InlineInput,
  NewsletterHeader,
  NewsletterInput,
} from './styles';

const Newsletter = ({ header }: PrismicSliceNewsletter) => {
  const { t } = useContext(AppContext);
  const {
    state: { signupFeedbackTranslationKey, isSubscribed, loading },
    handleSubmit,
    handleChange,
    privacyPolicyUri,
  } = useNewsletterSignup();

  return (
    <Container>
      {header ? (
        <NewsletterHeader>
          <H3Text>{header}</H3Text>
        </NewsletterHeader>
      ) : null}

      <NewsletterInput>
        {!isSubscribed ? (
          <Form method="post" onSubmit={handleSubmit}>
            <Flex>
              <InlineInput
                type="email"
                name="email"
                helper={t('campaigns', signupFeedbackTranslationKey!)}
                onChange={handleChange}
                variant="rounded"
                placeholder={t('campaigns', 'newsletter.email-placeholder')}
                ariaLabel={t('campaigns', 'newsletter.email-input-aria-label')}
                // Do not send this element to CUX (cux.io)
                data-cux-exclude
              />

              <Button loading={loading} htmlType="submit">
                {t('campaigns', 'newsletter.sign-up-button')}
              </Button>
            </Flex>
          </Form>
        ) : (
          <Text>
            <SubscribedCheckIcon />
            <SubscribeTitle>
              {t('campaigns', 'newsletter.sign-up-success')}
            </SubscribeTitle>
          </Text>
        )}
      </NewsletterInput>
      <LegalLink privacyPolicyUri={privacyPolicyUri} />
    </Container>
  );
};

export default Newsletter;
